import {put} from "redux-saga/effects";

import axios from "../../../../../api/axios"

import * as actions from "../../../../actions";
import * as api from "../../../../../api";
import {generateDynamicRoute} from "../../../../../utils/utils";

export function* adminAssignementsUtilisateurCategorieSupprimerAssignementUtilisateurCategorieSaga (action) {

    yield put(actions.adminAssignementsUtilisateurCategorieSupprimerAssignementUtilisateurCategorieStart());

    const assignementUtilisateurCategorieId = action.payload.assignementUtilisateurCategorieId;

    try {
        const response = yield axios.delete(generateDynamicRoute(api.supprimerAssignementUtilisateurCategorie,[{toReplace:":assignementUtilisateurCategorieId",value:assignementUtilisateurCategorieId}]));
        yield put(actions.adminAssignementsUtilisateurCategorieSupprimerAssignementUtilisateurCategorieSuccess(assignementUtilisateurCategorieId));
    } catch (error) {
        if(error.response) {
            yield put(actions.adminAssignementsUtilisateurCategorieSupprimerAssignementUtilisateurCategorieFail(error.response.data.error));
        }else {
            yield put(actions.adminAssignementsUtilisateurCategorieSupprimerAssignementUtilisateurCategorieFail("There's an error!"));
        }
    }
}

